/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Contact1stdibsLink_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"TradeRepCircle_viewer">;
    readonly " $refType": "Contact1stdibsLink_viewer";
};
export type Contact1stdibsLink_viewer$data = Contact1stdibsLink_viewer;
export type Contact1stdibsLink_viewer$key = {
    readonly " $data"?: Contact1stdibsLink_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Contact1stdibsLink_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Contact1stdibsLink_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasTradeUserId",
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "TradeRepCircle_viewer",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'db9854a6602b7d952b66ee3fa88e6732';
export default node;
